import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Close } from '../../icon/Close';
import { domElementModel } from '../../../../redux-modules/base/models';

import './modal.css';

class Modal extends Component {
  static modalCounter = 0;

  constructor(props) {
    super(props);

    this.modalRef = React.createRef();
    this.instance = null;

    this.state = { visible: false };

    this.handleModalShow = this.handleModalShow.bind(this);
    this.handleModalShown = this.handleModalShown.bind(this);
    this.handleModalHide = this.handleModalHide.bind(this);
    this.handleModalHidden = this.handleModalHidden.bind(this);
  }

  componentDidMount() {
    const { staticBackdrop } = this.props;
    this.instance = new window.bootstrap.Modal(this.modalRef.current, {
      backdrop: staticBackdrop ? 'static' : true,
      keyboard: !staticBackdrop,
    });
    const $modal = window.jQuery(this.modalRef.current);
    $modal.off('show.bs.modal', this.handleModalShow);
    $modal.off('shown.bs.modal', this.handleModalShown);
    $modal.off('hide.bs.modal', this.handleModalHide);
    $modal.off('hidden.bs.modal', this.handleModalHidden);
    $modal.on('show.bs.modal', this.handleModalShow);
    $modal.on('shown.bs.modal', this.handleModalShown);
    $modal.on('hide.bs.modal', this.handleModalHide);
    $modal.on('hidden.bs.modal', this.handleModalHidden);
  }

  componentWillUnmount() {
    this.instance.dispose();
    this.instance = null;
  }

  handleModalShow({ target }) {
    if (target !== this.modalRef.current) {
      return;
    }
    const { onShow } = this.props;
    this.setState({ visible: true });
    if (onShow) {
      onShow();
    }
    Modal.modalCounter += 1;
  }

  handleModalShown({ target }) {
    if (target !== this.modalRef.current) {
      return;
    }
    const { onShown } = this.props;
    if (Modal.modalCounter > 1) {
      const parentModal = target.parentNode.closest('.react-modal');
      if (parentModal) {
        parentModal.scrollTo(0, 0);
        parentModal.style.overflow = 'hidden';
      }
    } else {
      // eslint-disable-next-line no-param-reassign
      target.style.overflow = null;
    }
    if (onShown) {
      onShown();
    }
  }

  handleModalHide({ target }) {
    if (target !== this.modalRef.current) {
      return;
    }
    const { onHide } = this.props;
    if (onHide) {
      onHide();
    }
    Modal.modalCounter -= 1;
  }

  handleModalHidden({ target }) {
    if (target !== this.modalRef.current) {
      return;
    }
    const { onHidden } = this.props;
    this.setState({ visible: false });
    if (Modal.modalCounter > 0) {
      document.body.classList.add('modal-open');
      document.body.style.overflow = 'hidden';
      const parentModal = target.parentNode.closest('.react-modal');
      if (parentModal) {
        parentModal.style.overflow = null;
      }
    }
    if (onHidden) {
      onHidden();
    }
  }

  render() {
    const {
      title,
      small,
      alwaysVisible,
      staticBackdrop,
      children,
      onClose,
      hideClose,
    } = this.props;
    const { visible } = this.state;

    return (
      <div
        ref={this.modalRef}
        className="modal react-modal text-md-start"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        data-bs-backdrop={staticBackdrop ? 'static' : true}
        data-bs-keyboard={!staticBackdrop}
      >
        <div className={`modal-dialog modal-dialog-centered ${small ? 'modal-sm' : 'modal-xl'}`}>
          <div className="modal-content">
            <div className="modal-header">
              {!hideClose && (
                <button
                  className="modal-close"
                  type="button"
                  onClick={() => (onClose ? onClose(this.instance) : this.instance.hide())}
                >
                  <span className="visually-hidden">close</span>
                  <Close />
                </button>
              )}
              {small && (<h4>{title}</h4>)}
              {!small && (<h2>{title}</h2>)}
            </div>
            <hr className={`${small ? 'hr-strait' : 'mt-0 mb-6'}`} />
            <div className={`modal-body ${small ? '' : 'pt-lg-3'}`}>
              {(visible || alwaysVisible) && (children)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export { Modal };

Modal.propTypes = {
  title: PropTypes.string.isRequired,
  small: PropTypes.bool,
  alwaysVisible: PropTypes.bool,
  staticBackdrop: PropTypes.bool,
  children: domElementModel.isRequired,
  onClose: PropTypes.func,
  onShow: PropTypes.func,
  onShown: PropTypes.func,
  onHide: PropTypes.func,
  onHidden: PropTypes.func,
  hideClose: PropTypes.bool,
};

Modal.defaultProps = {
  small: false,
  alwaysVisible: false,
  staticBackdrop: false,
  onClose: null,
  onShow: null,
  onShown: null,
  onHide: null,
  onHidden: null,
  hideClose: false,
};
